import { Link } from "react-router-dom";
import { ArrowRight, Check, Clock, Globe } from "lucide-react";
import PageShell, { Section } from "@/components/site/PageShell";
import { Cards, Prose, Table } from "@/components/site/ui";
import { COACH } from "@/content/coach";

export default function Coach() {
  return (
    <PageShell
      eyebrow="Le coach"
      title={COACH.name}
      lead={COACH.tagline}
      actions={<>
        <Link to="/tarifs" className="button button-dark" data-testid="coach-pricing">Voir les tarifs<ArrowRight size={13} /></Link>
        <Link to="/auth" className="button button-outline">Créer mon compte</Link>
      </>}
    >
      <Section>
        <Prose>{COACH.intro.map((p, i) => <p key={i}>{p}</p>)}</Prose>
      </Section>

      <Section title="Les jeux couverts" lead="Cinq jeux, pour les connaître vraiment plutôt que d'en survoler vingt.">
        <Table
          head={["Jeu", "Niveau", "Ce qui est travaillé"]}
          rows={COACH.games.map(g => [g.label, g.level, g.note])}
        />
      </Section>

      <Section title="Références" id="references">
        <Prose>
          <ul>{COACH.credentials.map(c => <li key={c}>{c}</li>)}</ul>
        </Prose>
      </Section>

      <Section title="La méthode" id="methode" lead="Ce qui se passe pendant une séance, dans l'ordre.">
        <Cards items={COACH.method} />
      </Section>

      <Section title="Pratique">
        <Table rows={[
          ["Disponibilités", COACH.availability],
          ["Langues", COACH.languages.join(", ")],
          ["Durée d'une séance", "1 h, 1 h 30 ou 2 h"],
          ["Tarif", "De 56 à 200 € selon la durée et le module"],
          ["Annulation", "Gratuite jusqu'à 24 h avant"],
        ]} />
      </Section>

      <Section>
        <Prose>
          <p>
            Prêt à commencer ? <Link to="/tarifs">Regardez la grille tarifaire</Link> pour
            choisir le format, puis <Link to="/auth">créez votre compte</Link>.
          </p>
        </Prose>
      </Section>
    </PageShell>
  );
}
